﻿import { Box, IconButton, Modal, Stack, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import { BIBlue, BIGrey } from "../../assets/helpers";
import { useSelector } from "react-redux";
import { English } from "../../constant/EnglishFallback";

export default function Addsitename(props) {
  const [siteName, setSitename] = useState("");

  const { multiLanguageData } = useSelector((state) => state?.main);
  const {
    TEXT_ADD_SITE_NAME = English?.Map?.TEXT_ADD_SITE_NAME,
    TEXT_ENTER_SITE_NAME = English?.Map?.TEXT_ENTER_SITE_NAME
  } = multiLanguageData?.Map || {};

  const onSavesitename = () => {
    props.SavesitewithName(siteName);
    props.handleClose();
  };

  const onSitenamechange = (e) => {
    let inputValue = e.target.value;
    inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
    setSitename(inputValue);
  };

  return (
    <Modal open={props.showAddNameModal} onClose={props.handleClose}>
      <Box className="user-modal-responsive">
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Typography variant="h5" className="add-title">
            {TEXT_ADD_SITE_NAME}
          </Typography>
          <Stack direction={"row"}  sx={{ gap: 1, alignItems: "center" }}>
            <CloseIcon
              style={{ color: "#083DB8", cursor: "pointer" }}
              onClick={props.handleClose}
            />
            <IconButton disabled={siteName === ""} onClick={() => onSavesitename()}>
              <SaveIcon
                style={{
                  color: siteName === "" ? BIGrey : BIBlue,
                  cursor: "pointer"
                }}
              />
            </IconButton>
          </Stack>
        </Box>
        <TextField
          label={TEXT_ENTER_SITE_NAME}
          name="name"
          variant="outlined"
          fullWidth
          value={siteName}
          onChange={onSitenamechange}
        />
      </Box>
    </Modal>
  );
}
